import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, CodeBlock, SettingState,
} from '@appblocks/codegeneration/types';
import * as tios from './tios';

export default class Fd extends BaseFeature {
    constructor() {
        super();
        this.name = 'Flash Disk';
        this.id = 'fd';
        const settings = [
            {
                id: 'ENABLED',
                name: 'Flash Disk Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'FILES',
                name: 'Max Number of Files',
                settingType: SettingType.NUMBER,
                default: '32',
                required: true,
            },
            {
                id: 'SECTORS',
                name: 'Number of Sectors',
                settingType: SettingType.NUMBER,
                default: '100',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getDependencies(): string[] {
        return ['filenum'];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return [];
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/object_fd';
    }
}
